import React from 'react';
import {
    RunnerDetails,
    RunnerDetailsNumber,
    RunnerDetailsWrapper,
    RunnerNameAndPlace,
} from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails.style';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';

interface JockeyAndTrainerDetailsType {
    selection: SelectionModel;
    isUnnamedFavourite: boolean;
    className?: string;
}

export const JockeyAndTrainerDetails = observer(
    'JockeyAndTrainerDetails',
    (props: JockeyAndTrainerDetailsType): JSX.Element | null => {
        const { className, isUnnamedFavourite, selection } = props;

        if (selection.name === '') {
            return null;
        }

        const jockey = (selection.metaDataJockey ?? '').trim();
        const trainer = (selection.metaDataTrainer ?? '').trim();
        const number = (selection.metaDataNumber ?? '').trim();
        const drawn = (selection.metaDataDrawn ?? '').trim();

        const horseNumber = number !== '' && number !== '0' ? number : '';
        const horseNumberAndName = horseNumber === '' ? selection.name : `${horseNumber} ${selection.name}`;

        return (
            <div className={className}>
                <RunnerNameAndPlace
                    data-test='runner-name'
                    title={horseNumberAndName}
                >
                    {horseNumberAndName}
                </RunnerNameAndPlace>

                {isUnnamedFavourite ? null : (
                    <RunnerDetailsWrapper data-test='runner-description'>
                        {drawn !== '' && <RunnerDetailsNumber>({drawn})</RunnerDetailsNumber>}
                        {jockey !== '' && <RunnerDetails title={jockey}>{jockey}</RunnerDetails>}
                        {trainer !== '' && <RunnerDetails title={trainer}>{trainer}</RunnerDetails>}
                    </RunnerDetailsWrapper>
                )}
            </div>
        );
    }
);
